import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import Section, { SectionHeader, SectionTitle, SectionBody } from 'components/common/Section';
import Button from 'components/common/Button';
import TextField from 'components/fields/TextField';
import FormError from 'components/common/FormError';

import {
  createBusinessClaimMDCredentials, updateBusinessClaimMDCredentials,
} from 'redux/modules/business';

import * as validate from 'utils/validate';

const styles = theme => ({
  grid: {
    marginBottom: 10,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 4,
    },
  },
  gridGutter: {
    marginTop: 15,
  },
  button: {
    marginLeft: 20,
  },
  form: {
    width: 468,
    margin: '10px auto',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  buttons: {
    display: 'flex',
    flexWrap: 'nowrap',
  },
});

function onSubmit(values, dispatch, props) {
  if (props.initialValues['Account Key'] !== undefined) {
    return new Promise((resolve, reject) => {
      dispatch(updateBusinessClaimMDCredentials({
        values,
        resolve,
        reject,
      }));
    }).then(res => res,
      (err) => {
        if (err.error) {
          throw new SubmissionError({ _error: err.error });
        }
        throw new SubmissionError(err);
      });
  }
  return new Promise((resolve, reject) => {
    dispatch(createBusinessClaimMDCredentials({
      values,
      resolve,
      reject,
    }));
  }).then(res => res,
    (err) => {
      if (err.error) {
        throw new SubmissionError({ _error: err.error });
      }
      throw new SubmissionError(err);
    });
}

const BusinessClaimMDCredentialsForm = ({
  submit,
  reset,
  handleSubmit,
  submitting,
  error,
  classes,
}) => (
  <Section>
    <SectionHeader
      fixed
      top={110}
    >
      <SectionTitle>
        Claim MD Credentials
      </SectionTitle>
      <div className={classes.buttons}>
        <Button
          className={classes.button}
          variant="raised"
          onClick={reset}
        >
          Reset
        </Button>
        <Button
          className={classes.button}
          variant="raised"
          color="primary"
          disabled={submitting}
          onClick={submit}
        >
          Save
        </Button>
      </div>
    </SectionHeader>
    <SectionBody>
      <form
        className={classes.form}
        noValidate
        autoComplete="off"
        onSubmit={handleSubmit}
      >
        {error &&
          <Grid
            className={classes.grid}
            container
            spacing={24}
          >
            <Grid
              item
              xs={12}
            >
              <FormError>
                {error}
              </FormError>
            </Grid>
          </Grid>
        }
        <Grid
          className={classes.grid}
          container
          spacing={24}
        >
          <Grid item xs={12}>
            <Field
              id="Account Key"
              name="Account Key"
              label="Account Key"
              component={TextField}
              validate={[validate.required]}
              fullWidth
            />
          </Grid>
        </Grid>
      </form>
    </SectionBody>
  </Section>
);

BusinessClaimMDCredentialsForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  error: PropTypes.string,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
    gridGutter: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    form: PropTypes.string.isRequired,
  }).isRequired,
};

BusinessClaimMDCredentialsForm.defaultProps = {
  error: null,
};

export default reduxForm({
  onSubmit,
  enableReinitialize: true,
})(withStyles(styles)(BusinessClaimMDCredentialsForm));



// WEBPACK FOOTER //
// ./src/components/settings/BusinessClaimMDCredentialsForm/BusinessClaimMDCredentialsForm.js